import type {BestTimeCalculationState} from '@Libraries/best-send-time.library';

export const DEFAULT_SCHEDULE_TIME_DROPDOWN_ID = 'schedule-form-time';

export interface ScheduleFormBestTimeOptions {
  state: BestTimeCalculationState;
  optimalSendTime: Date | null;
  onEnable: (referenceDate: Date) => void;
  onDisable: () => void;
}

export interface ScheduleFormProps {
  initialDate: Date | null;
  isEditingExistingSchedule: boolean;
  showInlineTitle?: boolean;
  timeDropdownId?: string;
  onSave: (scheduleAt: Date, isBestTimeEnabled: boolean) => void;
  onRemove: () => void;
  bestTime?: ScheduleFormBestTimeOptions;
}

export interface ScheduleDateToSaveOptions {
  isBestTimeEnabled: boolean;
  optimalSendTime: Date | null;
  hasUserChosenDateTime: boolean;
  currentDateTime: Date;
  minAllowedDate: Date;
}
